import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { OverlayModule } from "@angular/cdk/overlay";
import { Overlay2Service } from "@lantern/app/core/utils/overlays/overlay2.service";
import {
  OVERLAY_CONTAINER_PROVIDER,
  OverlayContainerService
} from "./overlay-container.service";
import { OVERLAY_PROVIDER, OverlayService } from "./overlay.service";

@NgModule({
  imports: [CommonModule, OverlayModule],
  providers: [
    OVERLAY_CONTAINER_PROVIDER,
    OVERLAY_PROVIDER,
    OverlayContainerService,
    OverlayService,
    Overlay2Service
  ]
})
export class OverlaysModule {}
